import { useState, useEffect } from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import InstagramIcon from 'components/icons/instagramIcon'
import FacebookIcon from 'components/icons/facebookIcon'
import TwitterIcon from 'components/icons/twitterIcon'
import { GeneralLink } from 'components/common/typography'
import { today } from 'utils/dateUtils'
import { Section, ConditionalDiv } from 'components/common/common_styles'
import { MainContainer, MenuContainer, CopyrightContainer, MailingContainer, MailingList, IconContainer, AddressText } from './footer_styles'

const Footer = () => {
  const { prismicFooter: { data }, prismicLocation } = useStaticQuery(query)
  const [location, setLocation] = useState()

  useEffect(() => {
    const onGeoSuccess = position => {
      setLocation(position.coords)
    }
    navigator.geolocation?.getCurrentPosition(onGeoSuccess)
  }, [])

  const directionsLink = location ? prismicLocation.data.info_directions_link.replace(/{{start_position}}/g, `${location.latitude},${location.longitude}`) : undefined
  const directionsTitle = location ? prismicLocation.data.info_directions_title : '  '

  return (
    <Section as='footer' black>
      <MainContainer padLeft padRight padTop={2} padBottom={1}>
        <MenuContainer>
          {data.menus.map(menu =>
            <GeneralLink link={menu.link} key={menu.title}>{menu.title}</GeneralLink>
          )}
        </MenuContainer>
        <CopyrightContainer>
          ©{`${today().getFullYear()}`} SNOW PEAK | ALL RIGHTS RESERVED
        </CopyrightContainer>
        <MailingContainer>
          <MailingList>
            <ConditionalDiv desktopOnly>
              <div className='klaviyo-form-WstLsc' />
            </ConditionalDiv>
            <ConditionalDiv mobileOnly>
              <div className='klaviyo-form-Wugwpc' />
            </ConditionalDiv>
          </MailingList>
          <ConditionalDiv desktopOnly>
            <address>
              <AddressText data={data.address} />
              <GeneralLink link={directionsLink}>{directionsTitle}</GeneralLink>
            </address>
          </ConditionalDiv>
        </MailingContainer>
        <IconContainer>
          <a href={data.instagram_address} target='_blank' rel='noreferrer noopener' aria-label='instagram'>
            <InstagramIcon invert />
          </a>
          <a href={data.facebook_address} target='_blank' rel='noreferrer noopener' aria-label='facebook'>
            <FacebookIcon invert />
          </a>
          <a href={data.twitter_address} target='_blank' rel='noreferrer noopener' aria-label='twitter'>
            <TwitterIcon invert />
          </a>
        </IconContainer>
      </MainContainer>
    </Section>
  )
}

export default Footer

export const query = graphql`
  query {
    prismicFooter {
      data {
        address {
          richText
        }
        facebook_address
        instagram_address
        twitter_address
        menus {
          link
          title
        }
      }
    }
    prismicLocation {
      data {
        info_directions_title
        info_directions_link
      }
    }
  }
`
